module.exports = __webpack_public_path__ + "static/event-1-cc46da7e7a5ee23774c5243549920c37.mp4";